import styled from 'styled-components';
import { outlinedInputClasses, inputLabelClasses, SelectChangeEvent } from '@mui/material';
import FormControl from '@mui/material/FormControl';

export const Wrapper = styled.header`
  position: fixed;
  display: flex;
  align-items: center;
  height: 64px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.bgDark};
  justify-content: space-between;
  // background: ${({ theme }) => theme.colors.darkBlue};
  padding: 0 30px;
  z-index: 9000;
`;

export const Logo = styled.div`
  img {
    width: 150px;
  }
`;
export const StyledFormControl = styled(FormControl)({
  '.MuiSvgIcon-root': {
    fill: 'white',
  },
  [`& .${outlinedInputClasses.root} .${outlinedInputClasses.notchedOutline}`]: {
    borderColor: 'white',
  },
  [`&:hover .${outlinedInputClasses.root} .${outlinedInputClasses.notchedOutline}`]: {
    borderColor: 'white',
  },
  [`& .${outlinedInputClasses.root}.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
    borderColor: 'white',
  },
  [`& .${outlinedInputClasses.input}`]: {
    color: 'white',
  },
  [`&:hover .${outlinedInputClasses.input}`]: {
    color: 'white',
  },
  [`& .${outlinedInputClasses.root}.${outlinedInputClasses.focused} .${outlinedInputClasses.input}`]: {
    color: 'white',
  },
  [`& .${inputLabelClasses.outlined}`]: {
    color: 'white',
  },
  [`&:hover .${inputLabelClasses.outlined}`]: {
    color: 'white',
  },
  [`& .${inputLabelClasses.outlined}.${inputLabelClasses.focused}`]: {
    color: 'white',
  },
});
